function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "22.413",
  height: "21.368"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("path", {
  id: "Rectangle_3284",
  "data-name": "Rectangle 3284",
  fill: "none",
  d: "M0 0h22.413v21.368H0z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_6921",
  "data-name": "Group 6921"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_6921-2",
  "data-name": "Group 6921",
  clipPath: "url(#clip-path)",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_4194",
  "data-name": "Path 4194",
  d: "M14.478 10.884V10H3.467v1.314h10.7l.047-.083a2.592 2.592 0 01.266-.347"
}), /*#__PURE__*/React.createElement("path", {
  id: "Rectangle_3282",
  "data-name": "Rectangle 3282",
  transform: "translate(3.467 7.371)",
  d: "M0 0h11.011v1.314H0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Rectangle_3283",
  "data-name": "Rectangle 3283",
  transform: "translate(3.467 4.789)",
  d: "M0 0h6.981v1.314H0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_4195",
  "data-name": "Path 4195",
  d: "M3.467 12.629v1.314h9.18l.758-1.314z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_4196",
  "data-name": "Path 4196",
  d: "M3.467 15.257v1.314h7.662l.759-1.314z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_4197",
  "data-name": "Path 4197",
  d: "M10.285 18.033L10.3 18H2V2h10v4h4v4.008a2.625 2.625 0 01.427-.055 2.516 2.516 0 011.573.564V5l-5-5H1a1 1 0 00-1 .992v18.016A1 1 0 00.993 20h9.047a2.522 2.522 0 01.245-1.967"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_4198",
  "data-name": "Path 4198",
  d: "M16.427 11.953a.545.545 0 01.481.278l1.964 3.4 1.963 3.4a.557.557 0 01-.481.835H12.5a.557.557 0 01-.483-.835l1.964-3.4 1.963-3.4a.548.548 0 01.483-.278m0-1a1.543 1.543 0 00-1.349.778l-1.963 3.4-1.964 3.4a1.557 1.557 0 001.349 2.337h7.854a1.556 1.556 0 001.346-2.335l-1.963-3.4-1.964-3.4a1.539 1.539 0 00-1.347-.778"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_4199",
  "data-name": "Path 4199",
  d: "M16.906 13.919l-.174 3.474h-.594l-.177-3.474z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_4200",
  "data-name": "Path 4200",
  d: "M16.8 18.866a.482.482 0 01-.37.142.5.5 0 01-.377-.137.53.53 0 01-.135-.389.462.462 0 01.512-.515.49.49 0 01.372.136.529.529 0 01.129.379.539.539 0 01-.131.384"
})))));